import { loadPreferences } from '../api/managePreferences';
import { getDataParam } from '../utils/common';
import Raven from 'raven-js';
import { useEffect, useState } from 'react';
function getUserPreferences() {
  try {
    // Pre-validation for `data=<empty>` scenarios
    const dataQueryParam = getDataParam();
    if (!dataQueryParam) {
      return Promise.reject(new Error('Empty Data Param'));
    }
    return loadPreferences(dataQueryParam);
  } catch (err) {
    return Promise.reject(err);
  }
}
export default function useGetUserPreferences() {
  const [isLoading, setIsLoading] = useState(true);
  const [hasErrors, setHasError] = useState(false);
  const [data, setData] = useState(null);
  useEffect(() => {
    getUserPreferences().then(response => {
      if ('shouldRedirect' in response) {
        setData(response);
      } else {
        setData(Object.assign({}, response, {
          subscriptionStatuses: response.subscriptionStatuses || []
        }));
      }
      setIsLoading(false);
    }).catch(err => {
      setIsLoading(false);
      setHasError(true);
      Raven.captureException(err, {
        extra: {
          location: 'hooks/fallbackRetry/loadUserPreference'
        }
      });
    });
  }, []);
  return {
    isLoading,
    hasErrors,
    data
  };
}